import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  height: 200px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 100%;
  }
`;

export const BottomInfoContainer = styled.div`
  position: absolute;
  height: 50%;
  width: 100%;
  bottom: 0px;
  background-image: linear-gradient(
    to bottom,
    rgba(108, 108, 108, 0),
    ${({ theme }) => theme.palette.eclipse}
  );
`;

export const BottomInfo = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  padding: 0 20px;
`;

export const TopInfo = styled.div`
  position: absolute;
  display: flex;
  top: 20px;
  padding: 0 20px;
  width: 100%;
`;

export const TopInfoText = styled.span`
  font-size: 14px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => `${theme.palette.white}`};
`;

export const PriceContainer = styled.div``;
